import React from 'react';
const rows = [{
  before: 'Notti perse a cercare basi e schede su YouTube e Pinterest.',
  after: 'Unità didattiche complete e pronte sul tuo tablet in 2 clic.'
}, {
  before: 'Ansia prima di spiegare note, ritmo o pentagramma.',
  after: 'Sicurezza totale con il metodo dei colori e Body Percussion.'
}, {
  before: 'Alunni annoiati e distratti da lezioni solo teoriche.',
  after: 'Laboratori di "musica attiva" che incantano tutta la classe.'
}, {
  before: 'Verbali e valutazione descrittiva ti rubano i weekend.',
  after: 'Griglie e obiettivi già pronti, allineati alle nuove norme.'
}, {
  before: 'Saggi di Natale e fine anno = mesi di stress e improvvisazione.',
  after: 'Repertorio, copioni e basi pronti per ogni saggio della scuola.'
}];
const stats = [{
  value: '+200',
  label: 'ore risparmiate ogni anno',
  color: 'text-cta-green'
}, {
  value: '6',
  label: 'volumi pronti dalla 1ª alla 5ª',
  color: 'text-primary'
}, {
  value: '5 min',
  label: 'per pianificare la settimana',
  color: 'text-secondary'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        {/* Time cost callout — punchier with visible stat */}
        <div className="relative bg-gradient-to-br from-badge-red/15 to-badge-red/5 border border-badge-red/30 rounded-2xl p-6 sm:p-10 mb-12 overflow-hidden" data-id="element-113">
          <div className="absolute -top-20 -right-20 w-[300px] h-[300px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(239,68,68,0.12) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-114"></div>

          <div className="relative grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-6 sm:gap-8 items-center" data-id="element-115">
            {/* Big stat */}
            <div className="text-center sm:border-r sm:border-badge-red/20 sm:pr-8" data-id="element-116">
              <div className="text-badge-red font-black text-6xl sm:text-7xl leading-none tracking-tighter" data-id="element-117">
                200<span className="text-3xl sm:text-4xl" data-id="element-118">h</span>
              </div>
              <p className="text-badge-red/90 font-bold text-xs sm:text-sm uppercase tracking-wider mt-2" data-id="element-119">
                perse ogni anno
              </p>
            </div>

            {/* Copy */}
            <p className="text-text-main text-base sm:text-xl font-bold leading-relaxed text-center sm:text-left" data-id="element-120">
              Pianificare a mano lezioni di musica davvero efficaci ti toglie{' '}
              <span className="text-badge-red font-black" data-id="element-121">
                fino a 5 ore a settimana
              </span>
              .{' '}
              <span className="text-text-main" data-id="element-122">
                Musica Pronta ti restituisce ogni minuto —{' '}
              </span>
              <span className="text-cta-green font-black" data-id="element-123">
                anche se non sai leggere una nota.
              </span>
            </p>
          </div>
        </div>

        {/* Comparison table */}
        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-124">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-125">
            <div className="px-6 py-5 font-bold text-red-400 text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm flex items-center gap-2 justify-center md:justify-start" data-id="element-126">
              <span className="w-2 h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-127"></span>
              SENZA MUSICA PRONTA · OGGI
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm flex items-center gap-2 justify-center md:justify-start" data-id="element-128">
              <span className="w-2 h-2 rounded-full bg-cta-green" data-id="element-129"></span>
              CON MUSICA PRONTA · DOMANI
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-130">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-131">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20 relative" data-id="element-132">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-133">
                    <span className="text-badge-red font-bold text-sm" data-id="element-134">✕</span>
                  </div>
                  <p className="text-text-sec font-medium line-through decoration-badge-red/40 decoration-1" data-id="element-135">
                    {row.before}
                  </p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-gradient-to-r from-primary/[0.07] to-cta-green/[0.04] relative overflow-hidden" data-id="element-136">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-137"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/40 shadow-[0_0_10px_rgba(16,185,129,0.25)] relative z-10" data-id="element-138">
                    <span className="text-check-green font-bold text-sm" data-id="element-139">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-bold relative z-10" data-id="element-140">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Outcome stats strip */}
        <div className="mt-8 grid grid-cols-3 gap-3 sm:gap-6 bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-8" data-id="element-141">
          {stats.map((stat, i) => <div key={i} className={`text-center ${i < stats.length - 1 ? 'border-r border-border-light' : ''}`} data-id="element-142">
              <div className={`${stat.color} font-black text-2xl sm:text-4xl leading-none tracking-tight`} data-id="element-143">
                {stat.value}
              </div>
              <p className="text-text-sec text-[10px] sm:text-sm font-medium mt-2 leading-tight" data-id="element-144">
                {stat.label}
              </p>
            </div>)}
        </div>

        {/* Soft CTA */}
        <div className="text-center mt-10" data-id="element-145">
          <a href="#pricing" className="inline-flex items-center gap-2 text-cta-green font-black text-base sm:text-lg hover:gap-3 transition-all border-b-2 border-cta-green/40 hover:border-cta-green pb-1" data-id="element-146">
            👉 Voglio recuperare le mie 200 ore →
          </a>
        </div>
      </div>
    </section>;
}